import { Routes } from '@angular/router'

import { environment } from '@coty/env/environment'

export const interactionRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/'
  },

  ...(environment.features['module.free-mode']
    ? ([
        {
          path: 'free',
          loadChildren: () =>
            import('@yoshu-lib/features/interaction-modes/free-mode/free-mode.routes').then(
              (m) => m.default
            ),
          data: { workflow: 'rag' }
        }
      ] as Routes)
    : []),

  {
    path: 'issue/:interactionId',
    loadComponent: () =>
      import('./failure-mode/interaction-failure-mode.component').then(
        (m) => m.InteractionFailureModeComponent
      ),
    data: { workflow: 'coty' }
  },

  { path: '**', redirectTo: '/', pathMatch: 'full' }
]
